"use client";

import { ClerkProvider } from "@clerk/nextjs";
import type { Appearance } from "@clerk/ui";
import { dark } from "@clerk/ui/themes";
import { tailwind } from "@repo/tailwind-config";
import { useTheme } from "next-themes";
import type { ComponentProps } from "react";

export const AuthProvider = (
	properties: ComponentProps<typeof ClerkProvider>,
) => {
	const { resolvedTheme } = useTheme();
	const isDark = resolvedTheme === "dark";
	const baseTheme = isDark ? dark : undefined;
	const variables: Appearance["variables"] = {
		// Core
		fontFamily: tailwind.theme.fontFamily.sans.join(", "),
		fontFamilyButtons: tailwind.theme.fontFamily.sans.join(", "),
		fontSize: tailwind.theme.fontSize.sm[0],
		fontWeight: {
			bold: tailwind.theme.fontWeight.bold,
			normal: tailwind.theme.fontWeight.normal,
			medium: tailwind.theme.fontWeight.medium,
		},
		spacing: tailwind.theme.spacing[4],
	};

	const elements: Appearance["elements"] = {
		dividerLine: "bg-secondary",
		socialButtonsIconButton: "bg-primary",
		navbarButton: "text-primary",
		organizationSwitcherTrigger__open: "bg-primary",
		organizationPreviewMainIdentifier: "text-primary",
		organizationSwitcherTriggerIcon: "text-tertiary",
		organizationPreview__organizationSwitcherTrigger: "gap-2",
		organizationPreviewAvatarContainer: "shrink-0",
	};

	return (
		<ClerkProvider
			{...properties}
			appearance={{ theme: baseTheme, variables, elements }}
		/>
	);
};
